import styled, {css} from "styled-components";
import {Button} from "../Button/styles";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 100vh;
  color: black;

  @media only screen and (${({theme}) => theme.media.small}) {
    margin-bottom: 20vh;
  }
`

export const Title = styled.div`
  width: 100%;
  font-style: normal;
  font-size: 30px;
  line-height: 45px;
  font-weight: 600;
  text-align: center;
  margin: 50px 0 40px 0;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.title};

  @media only screen and (${({theme}) => theme.media.small}) {
    font-size: 40px;
    line-height: 54px;
  }
`

export const Text = styled.div`
  font-size: 24px;
  line-height: 60px;
  text-align: center;
  color: ${({theme}) => theme.colors.text};
  margin: 0 10% 80px;
`

export const Cards = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 5%;
  padding: 0 10%;

  @media only screen and (${({theme}) => theme.media.small}) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  @media only screen and (${({theme}) => theme.media.large}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const Card = styled.div`
  position: relative;
  background: ${({theme}) => theme.colors.secondaryBackground};
  ${({theme}) => css`border: 1px solid ${theme.colors.cardBorderColor}`};
  border-radius: 40px;
  padding: 4vw;
  cursor: pointer;
  
  &:hover {
    img {
      filter: blur(2px);
    }
    
    button {
      display: block;
    }
    border-color: rgba(179, 55, 108, 0.3);
  }

  @media only screen and (${({theme}) => theme.media.medium}) {
    padding: 30px;
  }
`

export const CardImageBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CardImage = styled.img`
  width: 100%;
  filter: blur(0);
  transition: 0.3s;
`

export const CardContainer = styled.div`
  margin-top: 30px;
`

export const CardTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 1rem;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.title};
`

export const CardText = styled.p`
  font-size: 22px;
  color: ${({theme}) => theme.colors.text};
`

export const CardDownloadButton = styled(Button)`
  display: none;
  position: absolute;
`